import "./notification-popup.scss";
import { Dispatch, SetStateAction } from "react";
import { NotificationResponse, NotificationType, useSetStatusFlagOfNotificationMutation, useSetEsignStatusFlagOfNotificationMutation } from "pages/authentication/userService";
import Notification from "./Notification";
interface NotsProps {
  notifications: NotificationResponse[] | undefined;
  setNotifications: Dispatch<SetStateAction<NotificationResponse[] | undefined>>;
}

export default function NotificationPopup({ notifications, setNotifications }: NotsProps) {
  const [updateNotificationStatus] = useSetStatusFlagOfNotificationMutation();
  const [updateEsignNotificationStatus] = useSetEsignStatusFlagOfNotificationMutation();

  const markAsViewed = (notification: NotificationResponse) => {
    const isEsign = notification?.notificationType?.toLowerCase() === NotificationType.Esign.toLowerCase();
    return isEsign ? updateEsignNotificationStatus(notification.id) : updateNotificationStatus(notification.id);
  };

  const handleRemoveViewedNotification = (id: string) => {
    if (!notifications) return;

    const notification = notifications.find((n) => n.id === id);
    if (notification) {
      void markAsViewed(notification);
    }
    setNotifications((prev) => prev?.filter((notification) => notification.id !== id));
  };

  return (
    <div className="notify-popup-container">
      <div className="notifiy-scroll">
        {notifications?.map((data, index) => (
          <Notification
            id={data.id}
            userId={data.userId}
            nhDealApplicationId={data.nhDealApplicationId}
            title={data.title}
            text={data.text}
            link={data.link}
            createdOn={data.createdOn}
            key={data.id || index}
            notificationType={data.notificationType}
            onRemoveViewedNotification={handleRemoveViewedNotification}
          />
        ))}
      </div>
    </div>
  );
}
